<template>
    <div>
        <div class="wheel text-center gotham-book h3 text-white">
            <p class="text-item">
                space planning -
                <br>
                commercial &amp; residential
            </p>
            <p class="text-item">
                residential design
                <br>
                &amp; decor
            </p>
            <p class="text-item">
                budget planning
            </p>
            <p class="text-item">
                concept tear sheets
                <br>
                for renderings
            </p>
            <p class="text-item">
                condo amenity
                <br>
                design &amp; decor
            </p>
            <p class="text-item">
                construction drawings
                &amp; specifications
            </p>
            <p class="text-item">
                finishes &amp; materials selection
            </p>
            <p class="text-item">
                procurement of furniture
                <br>
                accessories &amp; drapery
            </p>
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";

export default {
    data() {
        return {
            textWheel: null
        }
    },
    mounted() {
        this.$nextTick(() => {
            // ScrollTrigger.refresh();
            setTimeout(() => {
                this.textWheel = gsap;
                gsap.utils.toArray('.wheel').forEach((line, i) => {
                    const speed = 100 // (in pixels per second)
                    
                    const links = line.querySelectorAll(".text-item"),
                    tl = verticalLoop(links, i ? -speed : speed)

                    function verticalLoop(elements, speed) {
                        elements = gsap.utils.toArray(elements);
                        let firstBounds = elements[0].getBoundingClientRect(),
                            lastBounds = elements[elements.length - 1].getBoundingClientRect(),
                            top = firstBounds.top - firstBounds.height - Math.abs(elements[1].getBoundingClientRect().top - firstBounds.bottom),
                            bottom = lastBounds.top,
                            distance = bottom - top,
                            duration = Math.abs(distance / speed),
                            tl = gsap.timeline({repeat: -1}),
                            plus = speed < 0 ? "-=" : "+=",
                            minus = speed < 0 ? "+=" : "-=";

                            elements.forEach(el => {
                                let bounds = el.getBoundingClientRect(),
                                    ratio = Math.abs((bottom - bounds.top) / distance);
                                if (speed < 0) {
                                    ratio = 1 - ratio;
                                }

                                tl.to(el, {
                                    y: plus + distance * ratio,
                                    duration: duration * ratio,
                                    ease: "none"
                                }, 0);

                                tl.fromTo(el, {
                                    y: minus + distance,
                                }, 
                                {
                                    y: plus + (1 - ratio) * distance,
                                    ease: "none",
                                    duration: (1 - ratio) * duration,
                                    immediateRender: false
                                }, duration * ratio)
                            });
                            return tl;
                        }
                    });
            }, 500)
        })
    }
}
</script>

<style scoped lang="scss">
.wheel {
    position: relative;
    top: 3.5vw;
    white-space: nowrap;
    padding: 0;
    will-change: transform;
    display: flex;
    flex-direction: column;

    .text-item {
        display: inline-block
    }

}
</style>